export default __webpack_public_path__ + "static/media/11.5db34c25.jpg";